import { useBehavior, useTriggerAction } from '@libs/hooks';
import { ActionActionTypeEnum, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React, { Activity } from 'react';
import { SvgComponent } from '../../common/Svg/SvgComponent';
import { TDetailsSeparateTextData } from '../../types/data';
import { TDetailsSeparateTextOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './styles/detailsSeparateText.module.css';

export const DetailsSeparateText: React.FC<TWidgetProps<TDetailsSeparateTextData, TDetailsSeparateTextOption>> = ({ widget }) => {
    const { triggerActionsByType } = useTriggerAction(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    const { rightText, leftText, messages } = widget.data ?? ({} as TDetailsSeparateTextData);
    const { iconName, rightTextAlignment, rowSize } = widget.options ?? {};

    const onClick = () => {
        triggerActionsByType(ActionActionTypeEnum.onClick, {
            playerActionOptions: {
                textForCopyToClipboard: rightText,
                toastMessage: messages?.copiedText,
            },
        }).then();
    };

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <div
                className={clsx(styles.container, 'small' === rowSize && styles.small, isDisabled && styles.disabled, iconName && styles.interactive)}
                style={getInlineStyles({ margin: widget.options?.margin })}
                data-test={widget.uid}
            >
                <p className={styles.label}>{leftText}</p>
                <div
                    className={clsx(styles.rightSection, 'end' === rightTextAlignment && styles.rightSectionEnd)}
                    onClick={() => {
                        if (!isDisabled && iconName) {
                            onClick();
                        }
                    }}
                >
                    <p className={styles.text}>{rightText}</p>
                    {iconName && (
                        <div className={styles.iconContainer}>
                            <SvgComponent width={16} height={16} name={iconName} fill="black" />
                        </div>
                    )}
                </div>
            </div>
        </Activity>
    );
};
